export default __webpack_public_path__ + "static/source-separation-systems-product-filter-cec4c7dc5f6ceeed8480c96a317a7c08.mp4";